export const actionTypePrefix = '@@UserAvatarPopover';
export const reduxKey = '@@UserAvatarPopover';
